// @ts-ignore
export const all = (state) => state.all;

// @ts-ignore
export const dashboard = (state) => {
  // return events that are not in the past
  return state.all.filter((training) => {
    const eventDate = new Date(training.date);
    const today = new Date();

    return ((eventDate.getTime() - today.getTime()) / (1000 * 3600 * 24)) > 0;
  });
};

// @ts-ignore
export const one = (state) => state.one;

// @ts-ignore
export const guests = (state) => state.guests;

// @ts-ignore
export const templates = (state) => state.templates;

// @ts-ignore
export const ceos = (state) => state.ceos;
